import { useState } from 'react';

import { getLangRoute, Translations } from 'utils';
import { useMount } from 'utils/hooks';

const useLoadTranslations = () => {
  const [translations, setTranslations] = useState(null);

  useMount(() => {
    const getData = async () => {
      const data = await Translations.initialize({
        lang: getLangRoute(),
      });
      const responseData = data.getData();
      if (data.isNotEmpty() && responseData.translations) {
        setTranslations(responseData.translations);
      }
    };
    getData();
  });

  return translations;
};

export default useLoadTranslations;
